import { render, staticRenderFns } from "./DialogSelectStockType.vue?vue&type=template&id=2475bb3e&scoped=true"
import script from "./DialogSelectStockType.vue?vue&type=script&lang=js"
export * from "./DialogSelectStockType.vue?vue&type=script&lang=js"
import style0 from "./DialogSelectStockType.vue?vue&type=style&index=0&id=2475bb3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2475bb3e",
  null
  
)

export default component.exports